export default {
    information_please_choose: "请选择",
    information_please_fill_in: "请填写",
    organizer: "主办人员",
    fill_in_registration_information: "报名信息填写",
    incorrect_phone_number: "手机号格式不正确",
    incorrect_email: "邮箱格式不正确",
    please_contact_the_organizer: "报名申请提交成功！您的报名信息，我们已收到，我们会尽快同您联系。",
    submit: "确认提交",
    country: "国家",
    province: "省份",
    cannot_be_modified: "已报名过该展会，不可重复报名",
    exhibitor_registration: "展位申请",
    share: {
        interested: "想看",
        likes: "点赞",
        time: "开播时间",
        enter: "进入直播",
        pending: "待开始",
        live: "直播中",
        playback: "回放",
        finish: "已结束",
        introduction: "直播简介",
        exhibits: "展商详情",
        seen: "看过",
        looking: "看过" // 在看
    },
    comingSoon: "即将上线，敬请期待",
    comingSoonTitel: "敬请期待",
    cancel: "取消",
    confirm: "确认",
    layoutOfHall: '展馆布局图',
    floorplan: '展位图',
    trafficMap: '交通图',
    meetNums:"会议号",
    meetChair:'会议主持',
    meetJoinPeople:"参会人",
    invited:"已邀请",
    people:"人",
    meetStatus:{
       accepted:"已接受",
       noResponse:"未响应",
       rejected:"已拒绝"
    }
}